import type { ConceptDef } from '../types';

export const matchWordToPicture: ConceptDef = {
  kind: 'tileMatch',
  id: 'match-word-to-picture',
  label: 'Match Word-to-Picture',
  category: 'Matching',
  description: 'See a word; tap the matching picture.',
  config: {
    promptMode: 'TEXT',
    tileCount: 4,
    items: [
      { say: 'apple', answer: '🍎' },
      { say: 'dog', answer: '🐶' },
      { say: 'car', answer: '🚗' },
      { say: 'tree', answer: '🌳' },
      { say: 'ball', answer: '⚽' },
      { say: 'star', answer: '⭐' },
    ],
  },
};
